import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { backdropCloseHandlers } from '../../../../utils/backdropClose';
import './RenameProjectModal.css';

const RenameProjectModal = ({
  isOpen,
  projectName = '',
  initialName = '',
  isSubmitting = false,
  error = '',
  onCancel,
  onConfirm
}) => {
  const [name, setName] = useState(initialName || '');

  useEffect(() => {
    if (isOpen) {
      setName(initialName || '');
    }
  }, [isOpen, initialName]);

  if (!isOpen) {
    return null;
  }

  const trimmedName = name.trim();
  const disableOk = isSubmitting || trimmedName.length === 0;

  const handleClose = () => {
    if (isSubmitting) {
      return;
    }
    onCancel?.();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (disableOk) {
      return;
    }
    onConfirm?.(trimmedName);
  };

  const modalMarkup = (
    <div
      className="rename-project-modal-overlay"
      {...backdropCloseHandlers(handleClose)}
      role="dialog"
      aria-modal="true"
      aria-label="Rename project"
    >
      <div
        className="rename-project-modal-content"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="rename-project-modal-header">
          <h3>Rename Project</h3>
        </div>

        <form onSubmit={handleSubmit} className="rename-project-modal-form">
          <label className='rename-project-modal-form-label' htmlFor="rename-project-input">Please enter a new name</label>
          <input
            id="rename-project-input"
            type="text"
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="Enter project name"
            disabled={isSubmitting}
            autoFocus
          />

          {error ? <div className="rename-project-modal-error">{error}</div> : null}

          <div className="rename-project-modal-actions">
            <button
              type="button"
              id="rename-project-cancel-btn"
              className="rename-project-modal-btn rename-project-modal-btn-cancel"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              id="rename-project-save-btn"
              className={`rename-project-modal-btn rename-project-modal-btn-ok ${isSubmitting ? 'is-saving' : ''}`.trim()}
              disabled={disableOk}
              aria-busy={isSubmitting ? 'true' : 'false'}
            >
              {isSubmitting ? 'Saving...' : 'OK'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  return typeof document !== 'undefined'
    ? createPortal(modalMarkup, document.body)
    : modalMarkup;
};

export default RenameProjectModal;
